'use client';

var _Suspense;
import { lazy, Suspense } from 'react';
import { useIsRenderedFromWebView } from '@crehana/react-hooks/use-is-rendered-from-webview';
import { usePageIdle } from "../hooks/use-page-load-idle";
import { useUserPermissions } from "../hooks/use-user-permissions";
import { ErrorBoundary } from "../shared/components/error-boundary";
import { jsx as _jsx } from "react/jsx-runtime";
export var FloatingChatComponent = /*#__PURE__*/lazy(function () {
  return import("./floating-chat").then(function (module) {
    return {
      "default": module.HanaFloatingChat
    };
  });
});
export var HanaFloatingChatLazy = function HanaFloatingChatLazy() {
  var _useUserPermissions = useUserPermissions(),
    hasPermissions = _useUserPermissions.canAccessHanaAI;
  var isFromApps = useIsRenderedFromWebView();
  var isPageIdle = usePageIdle();
  if (!hasPermissions || !isPageIdle || isFromApps) {
    return null;
  }
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    fallback: null,
    onError: function onError(error, errorInfo) {
      console.error('Error loading FloatingChatComponent:', error, errorInfo);
    },
    children: _Suspense || (_Suspense = /*#__PURE__*/_jsx(Suspense, {
      fallback: null,
      children: /*#__PURE__*/_jsx(FloatingChatComponent, {})
    }))
  });
};